'use strict';

const replaceCurrencyFormattedValue = (formattedString, newValue) => {

    const newValueParts = newValue.toFixed(2).toString().split('.');

    const newValueInteger = newValueParts[0];
    const newValueDecimal = newValueParts.length > 1 ? newValueParts[1] : '00';

    const newFormattedValue = formattedString.replace(/[0-9]+([^0-9])[0-9]+/, newValueInteger + '$1' + newValueDecimal);

    return newFormattedValue;
};

module.exports = replaceCurrencyFormattedValue;
